/**
 * Polyfills
 *
 */

/***************************************************************************************************
 * BROWSER POLYFILLS
 */

/**
 */
import 'classlist.js'; // npm install classlist.js --save

/**
 *
 */
import 'web-animations-js'; // npm install web-animations-js --save

/***************************************************************************************************
 * Zone.js
 */
import 'zone.js';
